import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./app/App";
import { FournisseurAuth } from "./shared/auth/contexte";
import "./styles.css";

const racine = document.getElementById("racine");
if (!racine) throw new Error("Élément #racine absent de index.html.");

createRoot(racine).render(
  <StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <FournisseurAuth>
        <App />
      </FournisseurAuth>
    </BrowserRouter>
  </StrictMode>,
);
